import { apiClient } from '../../lib/api-client';
import { PATIENT_UHID_SEARCH_LIMIT } from '../../lib/patient-uhid-search';

interface ApiResponse<T> { success: true; data: T }
export interface VaccinationRows { success: true; data: Record<string, unknown>[]; pagination: { page: number; limit: number; total: number; totalPages: number } }
export interface VaccinationLookup { id: string; label: string; code?: string; [key: string]: unknown }
export type VaccinationLookupType = 'vaccines' | 'vendors' | 'stock' | 'patients' | 'vaccinations';

const compact = (params: Record<string, unknown>) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined),
);

export const fetchVaccinationDashboard = async () => (
  await apiClient.get<ApiResponse<Record<string, unknown>>>('/vaccination/dashboard')
).data.data;

export const fetchVaccinationRows = async (resource: string, params: Record<string, unknown> = {}) => (
  await apiClient.get<VaccinationRows>(`/vaccination/${resource}`, { params: compact({ page: 1, limit: 100, ...params }) })
).data;

export const fetchVaccinationLookup = async (type: VaccinationLookupType, params: Record<string, unknown> = {}) => (
  await apiClient.get<ApiResponse<VaccinationLookup[]>>('/vaccination/lookups', {
    params: compact({ type, ...params, limit: type === 'patients' ? PATIENT_UHID_SEARCH_LIMIT : 500 }),
  })
).data.data;

export const fetchVaccinationReport = async (params: Record<string, unknown> = {}) => (
  await apiClient.get<ApiResponse<Record<string, unknown>>>('/vaccination/reports', { params: compact(params) })
).data.data;

export const createVaccinationRecord = async (resource: string, payload: object) => (
  await apiClient.post<ApiResponse<Record<string, unknown>>>(`/vaccination/${resource}`, payload)
).data.data;

export const patchVaccinationRecord = async (resource: string, id: string, payload: object, action?: string) => (
  await apiClient.patch<ApiResponse<Record<string, unknown>>>(`/vaccination/${resource}/${id}${action ? `/${action}` : ''}`, payload)
).data.data;
